import type { ApiPlan } from '@/types/usage';

export function isPostpaidPlan(plan?: Pick<ApiPlan, 'name'> | null): boolean {
  if (!plan) return false;

  return plan.name.toLowerCase().replace(/[\s_-]/g, '') === 'postpaid';
}

export function isPrepaidPlan(plan?: Pick<ApiPlan, 'name'> | null): boolean {
  if (!plan) return false;

  return plan.name.toLowerCase().replace(/[\s_-]/g, '') === 'prepaid';
}
